import { Card } from '@shopify/polaris';
import { CustomTableStyled } from './styled';
import styled from 'styled-components';

interface IHeading {
  title: React.ReactNode;
  width?: string;
}

interface IProps {
  headings: IHeading[];
  rows?: React.ReactNode[][];
  rowMarkup?: React.ReactNode[];
}

const TableWrapper = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
`;

const TableCell = styled.td`
  padding: 12px;
  overflow-x: auto;

  /* Hide scrollbar for cleaner look but maintain functionality */
  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 2px;
  }

  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;

  /* Content wrapper */
  > div {
    min-width: 100%;
    width: fit-content;
  }
`;

const TableHeader = styled.th`
  padding: 12px;
  background: #f4f6f8;
  text-align: left;
  position: sticky;
  top: 0;
`;

const CustomTable = ({ headings, rows, rowMarkup }: IProps) => {
  return (
    <CustomTableStyled>
      <Card padding="0">
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                {headings.map((heading, index) => (
                  <TableHeader style={{ width: heading.width }} key={index}>
                    {heading.title}
                  </TableHeader>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows?.map((row, index) => (
                <tr key={index}>
                  {row.map((cell, i) => (
                    <TableCell key={i}>
                      <div>{cell}</div>
                    </TableCell>
                  ))}
                </tr>
              ))}
              {rowMarkup?.map((row) => row)}
            </tbody>
          </Table>
        </TableWrapper>
      </Card>
    </CustomTableStyled>
  );
};

export default CustomTable;
